import { createSlice } from '@reduxjs/toolkit';

const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    isOrientationCallModalOpen: false,
    isLimitModalOpen: false,
  },
  reducers: {
    openOrientationCallModal: (state) => {
      state.isOrientationCallModalOpen = true;
    },
    closeOrientationCallModal: (state) => {
      state.isOrientationCallModalOpen = false;
    },
    openCalendlyOnLimitModal: (state) => {
      state.isLimitModalOpen = true;
    },
    closeCalendlyOnLimitModal: (state) => {
      state.isLimitModalOpen = false;
    },
  },
});

export const {
  openOrientationCallModal,
  closeOrientationCallModal,
  openCalendlyOnLimitModal,
  closeCalendlyOnLimitModal,
} = modalSlice.actions;
export default modalSlice.reducer;
